module.exports = __webpack_public_path__ + "img/spinner-solid.5b9b60f8.svg";